import React from 'react';
import './Presence.css';

const states = [
  'Himachal Pradesh',
  'Delhi',
  'Punjab',
  'Haryana',
  'Chandigarh',
  'Uttarakhand',
  'J & K'
];

const Presence = () => {
  return (
    <section className="presence-page">
      <h2>Our Presence</h2>
      <p className="intro">
        Harrygen Labs is proud to be operational in the following regions of India:
      </p>

      <ul className="state-list">
        {states.map((state, index) => (
          <li key={index}>• {state}</li>
        ))}
      </ul>

      <div className="map-wrapper">
        <img src="/map.png" alt="Harrygen Map" className="presence-map" />
      </div>
    </section>
  );
};

export default Presence;
